import React from 'react';
import Navigation from '../../components/navigation'
import bg1 from './../../images/1.png'
import {Link} from 'react-router-dom'
import './index.css'
export default class culture extends React.Component {
    state = {
    }
    componentWillMount(){
        
    }
    render(){
        return (
            <main>
                <Navigation tab="culture"></Navigation>
                <div className="culture_container">
                    <div className="left_inner">
                            <Link to="/culture/4">
                        <div className="top">
                            <div className="cover">
                                <p>你真正了解击剑文化吗？</p>
                            </div>
                        </div>
                            </Link>
                        {/* <div className="middle">
                            <Link to="/culture/1">
                                <p>击剑理论课程</p>
                                <img src={require('./../../pic/culture_01.jpg')} alt=""></img>
                            </Link>
                        </div> */}
                        <div className="bottom">
                            <ul>
                                <li>
                                <Link to="/culture/2">
                                    <img src={require('./../../pic/culture_02.jpg')} alt=""></img>
                                    <div className="content">
                                        <p>击剑比的是心智、传递的是文化</p>
                                        <p>在人们的印象中，击剑选手是运动员中素质和涵养比较高的一个群体。“击剑来自于宫廷，是一项很绅士的运动，最开始的时候，选手在比赛时后手要张开扬起，像是在跟对手说：我手里没有暗器。两个人比赛，光明正大，堂堂正正，不会为了胜利不择手段；交手时点到即止，不会‘赶尽杀绝’。可以说，击剑文化所蕴含的，都是一些正能量的东西。 ”</p>
                                        <p></p>
                                    </div>
                                </Link>
                                </li>
                                <li>
                                <Link to="/culture/5">
                                    <img src={require('./../../pic/culture_05.jpg')} alt=""></img>
                                    <div className="content">
                                        <p>贵族击剑对决的礼仪 常用的击剑礼仪</p>
                                        <p>十六世纪欧洲，击剑是宫廷贵族决斗兼娱乐的主要活动之一。身穿带花边的贵族服装，右手执剑左手叉腰，脚站丁字步，一声令下，即使是如仇人相见的决斗之前，服装礼仪一样不可缺。</p>
                                        <p></p>
                                    </div>
                                </Link>
                                </li>
                                <li>
                                <Link to="/culture/3">
                                    <img src={require('./../../pic/culture_03.jpg')} alt=""></img>
                                    <div className="content">
                                        <p>击剑文化，强者的文化</p>
                                        <p>击剑文化是一种强者的文化。它的“强”不仅仅体现在对决者胜负的结果。更是体现在一种精神意志的状态中。</p>
                                        <p></p>
                                    </div>
                                </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="right_inner">
                        <div className="top">
                            <img src={require('./../../pic/know02.jpg')} alt=""></img>
                            <div>
                                <p>击剑小故事</p>
                                <p>揭秘击剑大咖如何走上击剑之路</p>
                                <p>仲满本来练的是田径，仲满1983年2月出生于江苏省南通市海安县老北凌乡。他的父亲是个体育爱好者，曾经代表南通六县参加江苏省足球比赛，踢的是后卫。</p>
                                <Link to="/culture/9"><p>查看详情</p></Link>
                            </div>
                        </div>
                        <div className="bottom">
                            <p>击剑小知识</p>
                            <p><Link to="/culture/6">击剑冷知识</Link></p>
                            <p><Link to="/culture/7">击剑起源与礼仪</Link></p>
                            <p><Link to="/culture/8">击剑的规则</Link></p>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
};